import { render } from "./MainBottomFooter.vue?vue&type=template&id=a34fe5aa&scoped=true"
import script from "./MainBottomFooter.vue?vue&type=script&lang=js"
export * from "./MainBottomFooter.vue?vue&type=script&lang=js"

import "./MainBottomFooter.vue?vue&type=style&index=0&id=a34fe5aa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a34fe5aa"]])

export default __exports__